<div>
  <div class="strong-text">{{ uiService.productName }} is not authorized to access this resource on your behalf.</div>
  <div>
    If this issue is in your primary environment, update the AWS Organization's SCP to permit
    {{ uiService.productName }}
    access to the resource or remove it from your application.
  </div>
  <div>
    If {{ uiService.productName }} is not permitted to create resources in your recovery environment due to this SCP
    requiring tags, visit <a href="{{ accountResourceTagsUrl }}">this page</a> to configure those tags. Otherwise,
    remove the resource from your {{ uiService.productName }} application.
  </div>
  <div>
    If neither of these help, <a [routerLink]="accountSupportUrl" routerLinkActive="activated-route">reach out</a> for
    assistance.
  </div>
  <div class="padding-top overflow-x-scroll">
    Original error message: <span class="code small">{{ issue.message }}</span>
  </div>
</div>
